import * as Yup from 'yup';

export const loginSchema = Yup.object({
  emailMobile: Yup.string().required('Please Enter Email')
});

export const otpSchema = Yup.object({
  OTP1: Yup.string().required('Please Enter OTP'),
  OTP2: Yup.string().required('Please Enter OTP'),
  OTP3: Yup.string().required('Please Enter OTP'),
  OTP4: Yup.string().required('Please Enter OTP'),
  OTP5: Yup.string().required('Please Enter OTP'),
  OTP6: Yup.string().required('Please Enter OTP')
});

export const leaveTypeSchema = Yup.object({
  name: Yup.string().required('Please Enter Name').min(3, 'Name must be at least 3 characters'),
  code: Yup.string().required('Please Enter Code'),
  type: Yup.string().required('Please Enter Type'),
  // balanceBasedOn: Yup.string().required('Please Select Balance Based On'),
  description: Yup.string().nullable(),
  // .required('Please Enter Description')
  // .min(10, 'Description must be at least 10 characters'),
  // startDate: Yup.string().nullable(),
  effectiveStartDate: Yup.string().required('Please Select Start Date'),
  effectiveEndDate: Yup.string().required('Please Select End Date'),
  maritalStatus: Yup.array().nullable(),
  departMentData: Yup.array().nullable(),
  employData: Yup.array().nullable(),
  designationInput: Yup.array().nullable()
});

export const kpiFormSchema = Yup.object({
  name: Yup.string().required('Please Enter Name').min(3, 'Name must be at least 3 characters'),
  description: Yup.string().nullable(),
  department: Yup.array().nullable(),
  employee: Yup.array().nullable(),
  designation: Yup.array().nullable()
}).test('at-least-one', null, function (value) {
  const { department, employee, designation } = value;
  if (department?.length > 0 || employee?.length > 0 || designation?.length > 0) {
    return true;
  }

  const errorMessage = 'At least one of Department, Employee, or Designation is required';

  // Return errors for all three fields
  return (
    this.createError({
      path: 'department',
      message: errorMessage
    }) ||
    this.createError({
      path: 'employee',
      message: errorMessage
    }) ||
    this.createError({
      path: 'designation',
      message: errorMessage
    })
  );
});

export const holidaySchema = Yup.object({
  name: Yup.string().required('Please Enter Name'),
  description: Yup.string(),
  date: Yup.string().required('Please Enter Date'),
  locality: Yup.array()
    .of(Yup.string())
    .min(1, 'Please Select Locality')
    .required('Please Select Locality')
});

export const departmentLeadSchema = Yup.object({
  name: Yup.string().required('Please Enter Name').min(3, 'Name must be at least 3 characters'),
  departmentLead: Yup.string().required('Please Select Lead Name')
});

export const employeeSchema = Yup.object({
  firstName: Yup.string().nullable(),
  lastName: Yup.string().nullable(),
  email: Yup.string().required('Please Enter Email').email('Please enter a valid email address'),
  phone: Yup.string()
    .required('Please Enter Mobile')
    .matches(/^[0-9]+$/, 'Mobile number must contain only digits')
    .matches(/^\d{10}$/, 'Please enter a valid 10-digit mobile number'),
  dateOfJoining: Yup.string().nullable(),
  dateOfBirth: Yup.string().nullable(),
  // .typeError('Please Select Date of Birth'),
  emergencyMobile: Yup.string().nullable(),
  personalEmail: Yup.string()
    .required('Please Enter Personal Email')
    .email('Please enter a valid email address'),
  location: Yup.string().nullable(),
  gender: Yup.string().nullable(),
  nationality: Yup.string().nullable(),
  sourceOfHire: Yup.string().nullable(),
  maritalStatus: Yup.string().nullable(),
  employeeType: Yup.string().nullable(),
  department: Yup.string().nullable(),
  designation: Yup.string().required('Please Select Designation'),
  reportingManager: Yup.array()
    .of(Yup.string())
    .min(1, 'Select at least one reporting manager')
    .required('Select at least one reporting manager'),
  workExperience: Yup.array(),
  educationDetails: Yup.array(),
  zohoEmployeeId: Yup.string()
    .required('Please Enter Zoho Employee ID')
    .matches(/^[0-9]+$/, 'Zoho Employee ID must contain only digits')
});

export const designationSchema = Yup.object({
  name: Yup.string().required('Please Enter Name').min(3, 'Name must be at least 3 characters')
});

export const leaveBalanceSchema = Yup.object({
  userId: Yup.string().required('Please Select Name'),
  leaveTypeId: Yup.string().nullable(),
  availableBalance: Yup.string().nullable(),
  bookedBalance: Yup.string().nullable()
});

const assetsBaseShape = {
  userId: Yup.string().required('Please Select Name')
};

export const buildAssetsSchema = (customFieldKeys = []) => {
  const extra = {};
  customFieldKeys.forEach((key) => {
    extra[key] = Yup.string().nullable();
  });
  return Yup.object({ ...assetsBaseShape, ...extra });
};

export const assetsSchema = buildAssetsSchema([]);

export const adminProfile = Yup.object({
  name: Yup.string().required('Please Enter Name'),
  email: Yup.string().required('Please Enter Email Name'),
  phone: Yup.number().required('Please Enter Mobile Number')
});

export const leaveRequestSchema = Yup.object({
  leaveTypeId: Yup.string().required('Please Select Leave Type'),
  userId: Yup.string().nullable(),
  startDate: Yup.string().required('Please Select Start Date'),
  endDate: Yup.string().required('Please Select End Date'),
  note: Yup.string()
    .required('Reason is required')
    .test('not-only-whitespace', 'Name cannot be only whitespace', (value) => {
      return value && value.trim().length > 0;
    }),
  dateOfRequest: Yup.string(),
  leaveTaken: Yup.string().nullable(),
  leaveDetails: Yup.array().nullable()
});

export const supportRequestSchema = Yup.object({
  userId: Yup.string().nullable(),
  dateOfRequest: Yup.string(),
  requestReason: Yup.string()
    .required('Please Enter Reason')
    .test('not-only-whitespace', 'Name cannot be only whitespace', (value) => {
      return value && value.trim().length > 0;
    })
});
